<template>
    <div class="rhythmClass">
        <el-col :span="24" class="zhiAudio" align="left" v-if="heart.questionDto.detailInfo.audioUrl">
            <audio-style 
                style="width:180px;float:left"
                ref="audioRef"
                @startPlaying="startPlaying"
                @endPlaying="endPlaying"
                @getPlays="getPlays"
                :styleText="'请点击播放'"
                :audioUrl="heart.questionDto.detailInfo.audioUrl"
                class="audioCom"
            ></audio-style>
            <div class="playNum" v-if="heart.questionDto.detailInfo.playTime!=-1">
                <div class="playNumIng"><img src="./../../../static/images/play.png" alt="" srcset=""></div>
                {{`X${plays}`}}
            </div>
        </el-col>
        <el-col :span="24" class="explainText" v-if="heart.questionDto.detailInfo.audioUrl">
            点击音频部分播放，选择正确答案
        </el-col>
        <el-col :span="24" class="imgStyle" align="left">
            <!-- 单选 选项为空 -->
            <div class="advancedOptions" v-show="radioMode">
                <img class="imgStyleUrl" :src="heart.questionDto.detailInfo.questionImgUrl" alt="" srcset="">
                <div style="clear: both;"></div>
                <div class="styleCent" v-for="(item,i) in heart.questionDto.detailInfo.detailsList" :key="i" :style="{color:(item.isAnswer==1? '#00D05D':advancedRadio.indexOf(item.bId)!=-1? 'red':'')}">
                    <el-checkbox-group v-model="advancedRadio" class="opRadio" size="medium">
                        <el-checkbox :label="item.bId" :class="item.isAnswer==1? 'green-select':advancedRadio.indexOf(item.bId)!=-1? 'red-select':''">&nbsp;</el-checkbox>
                    </el-checkbox-group>
                    <div class="options_A" @click="advancedRadio=item.bId">{{item.msg.substr(0, 1)}}</div>
                    <div :class="item.isAnswer==1? 'hook-dui':advancedRadio.indexOf(item.bId)!=-1? 'hook-cuo':''"></div>
                </div>
            </div>
            <!-- 单选 选项非空 -->
            <div class="optionsHaveValue" v-show="!radioMode">
                <img class="imgStyleUrl" :src="heart.questionDto.detailInfo.questionImgUrl" alt="" srcset="">
                <div class="styleCent" v-for="(item,i) in heart.questionDto.detailInfo.detailsList" :key="i" :style="{color:(item.isAnswer==1? '#00D05D':advancedRadio.indexOf(item.bId)!=-1? 'red':'')}">
                    <el-checkbox-group v-model="advancedRadio" class="opRadio" size="medium">
                        <el-checkbox :label="item.bId" :class="item.isAnswer==1? 'green-select':advancedRadio.indexOf(item.bId)!=-1? 'red-select':''">&nbsp;</el-checkbox>
                    </el-checkbox-group>
                    <div class="options_A textAlign" @click="advancedRadio=item.bId" v-html="item.msg">{{item.msg}}</div>
                    <div :class="item.isAnswer==1? 'hook-dui':advancedRadio.indexOf(item.bId)!=-1? 'hook-cuo':''"></div>
                </div>
            </div>
        </el-col>
    </div>
</template>
<script>
import audioStyle from '../../components/audioStyle'
import utils from '../../lib/util'
    export default {
        name:"rhythmChoice",
        props: {
            sonData: Object,
        },
        data() {
            return {
                heart:{
                    questionDto:{
                        detailInfo:{}
                    }
                },
                rhythmBeatVal:[],
                timeHer:'',
                advancedRadio:[],
                radioMode:true,
                plays:0,
            }
        },
        components:{
            audioStyle
        },
        watch: {},
        computed:{},
        created(){},
        mounted(){
            this.heart = this.sonData
            this.$nextTick(function(){
                this.rhythmBeatVal = []
                this.plays = utils.mottoClone(this.heart.questionDto.detailInfo.playTime)
                this.advancedRadio.push(Number(this.heart.errorObj.selectIds))
                let heartDto = this.heart.questionDto.detailInfo.detailsList
                let fleg = true
                heartDto.forEach((ele,i) => {
                    if(ele.msg){
                        fleg=false
                        ele.msg = this.blea(i)+ utils.dealText(ele.msg)
                    }else{ele.msg = this.blea(i)}
                    if(ele.isAnswer == 1){
                        this.advancedRadio.push(ele.bId)
                    }
                });
                if(!fleg) this.radioMode=false
            })
        },
        methods:{
            getPlays(){
                //限定播放次数
                this.$refs.audioRef.fatherPlay(this.plays,this.heart.questionDto.detailInfo.playTime)
            },
            startPlaying(){
                
            },
            endPlaying(){
                if(this.plays<=0) this.plays=0
                else this.plays--;
            },
            endAudio(){
                if(!this.heart.questionDto.detailInfo.audioUrl) return
                if(!this.$refs.audioRef.judgePaying()){
                    this.endPlaying()
                }
                this.$refs.audioRef.endAudio()
            },
            blea(s){
                return s==0? 'A、':s==1? 'B、':s==2? 'C、':s==3? 'D、':''
            },
        }
    }
</script>
<style scoped lang="less">
    .rhythmClass{
        height: 100%;
        width: 100%;
        .zhiAudio{
            height: 33px;
            width: 100%;
            box-sizing: border-box;
            padding-left: 16px;
            .playNum{
                float: left;
                display: inline-block;
                height: 33px;
                width: 100px;
                .playNumIng{
                    display: inline-block;
                    img{
                        margin: 5px 0 0 15px;
                        vertical-align: text-bottom;
                    }
                }
            }
        }
        .explainText{
            box-sizing: border-box;
            padding:5px 0 0 16px;
            text-align: left;
            font-size: 12px;
            color: #A0A1A0;
        }
        .imgStyle{
            width: 100%;
            height: 90%;
            box-sizing: border-box;
            padding: 25px 18px;
            
            //图片单选 选项为空
            .advancedOptions{
                height: 100%;
                .imgStyleUrl{
                    max-height: 30%;
                    max-width: 85%;
                }
                .styleCent{
                    width: 20%;
                    float: left;
                    margin: 4% 2.5%;
                    pointer-events: none;
                    .opRadio{
                        width: 10%;
                        height: 60px;
                        line-height: 60px;
                        text-align: end;
                        float: left;
                        margin-right: 0;
                    }
                    .options_A{
                        width: 80%;
                        height: 60px;
                        line-height: 60px;
                        text-align: center;
                        background-image: url('../../../static/images/opt.png');
                        background-size: 100% 100%;
                        background-position: 0px 0;
                        float: left;
                    }
                    .opRadio_active{background-image: url('../../../static/images/zhongOpt.png');}
                    .options_A:active{
                        background-image: url('../../../static/images/zhongOpt.png');
                    }
                }
            }
            // 图片单选 选项非为空
            .optionsHaveValue{
                height: 100%;
                pointer-events: none;
                .imgStyleUrl{
                    height: 25%;
                    max-width: 85%;
                }
                .styleCent{
                    width: 100%;
                    float: left;
                    margin: 0 0%;
                    .opRadio{
                        width: 40px;
                        height: 60px;
                        line-height: 60px;
                        text-align: end;
                        float: left;
                        margin-right: 0;
                    }
                    .options_A{
                        width: 90%;
                        height: 60px;
                        line-height: 60px;
                        text-align: center;
                        background-image: url('../../../static/images/opt.png');
                        background-size: 103% 100%;
                        background-position: -15px 1px;
                        float: left;
                    }
                    .opRadio_active{background-image: url('../../../static/images/zhongOpt.png');}
                    .options_A:active{
                        background-image: url('../../../static/images/zhongOpt.png');
                    }
                    .textAlign{
                        text-align: left;
                        padding-left: 30px;
                        box-sizing: border-box;
                    }
                }
            }
        }
    }
    .hook-dui{
        height: 15px;
        width: 15px;
        margin-top: 22.5px;
        float: left;
        background-image: url('../../../static/images/dui.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
    .hook-cuo{
        height: 15px;
        width: 15px;
        margin-top: 22.5px;
        float: left;
        background-image: url('../../../static/images/cuo.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
</style>
<style>
    .styleCent .el-radio__inner{
        height: 18px;
        width: 18px;
    }
    .textAlign .tableimg{
        height: 37px;
        max-height: 37px !important;
        width: 80% !important;

        position: relative;
        display: inline-block;
        vertical-align: middle;
    }
    .textAlign .tableimg img{
        max-width: 100%;
        max-height: 100%;
        position: absolute;
        top: 0;
        /* right: 0; */
        bottom: 0;
        left: 0;
        display: block;
        margin: auto 0;
    }
    .styleCent .green-select.is-checked .el-checkbox__inner{
        background-color: #00D05D;
        border-color: #00D05D;
    }
    .styleCent .red-select.is-checked .el-checkbox__inner{
        background-color: red;
        border-color: red;
    }
</style>



// WEBPACK FOOTER //
// src/components/examRecords/singleChoice_err.vue